import React from 'react';
import { Translate as T } from 'react-redux-i18n';
import { M } from '@dashboard-experience/mastodon';
import { InterpolationValues } from 'types/candidateStories';

interface ExampleListProps {
  exampleKeys: string[];
  interpolationValues?: InterpolationValues;
}

const ExampleList = ({
  exampleKeys,
  interpolationValues,
}: ExampleListProps) => (
  <>
    <p className='text-muted mb-0'>
      <T value='components.Report.examples' />
    </p>
    <M.UnorderedList className='mb-2' data-testid='example-list'>
      {exampleKeys.map(key => (
        <M.ListItem
          key={key}
          className='text-muted'
          data-testid='example-list-item'
        >
          <T value={key} {...interpolationValues} />
        </M.ListItem>
      ))}
    </M.UnorderedList>
  </>
);

export default ExampleList;
